/**
 * Transform the Digital OM to include empty and filled component states
 *
 * @param  {Array} layouts
 * @param  {Object} DOM
 * @return {Object}
 */
export const normalizeComponents = (layouts, dom) => {
    dom.sections = dom.sections.map(section => {
        section.pages = section.pages.map(page => {
            let totalComponents = layouts.find(i => i.name === page.layout).components
            let arr = new Array(totalComponents).fill({}).map((item, idx) => {
                return {
                    id: null,
                    meta: {},
                    page: page.id,
                    position: idx,
                    type: null,
                    value: null
                }
            })
            page.components.forEach(i => {
                arr[i.position] = i
            })
            page.components = arr
            return page
        })
        return section
    })
    return dom
}



// WEBPACK FOOTER //
// ./src/services/DomService.js